import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/all', label: '电影分类' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background-950/95 backdrop-blur-lg shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap group">
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
              <i className="ri-movie-2-fill text-primary-500 text-2xl md:text-3xl group-hover:scale-110 transition-transform duration-300"></i>
            </div>
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-50 tracking-wide">
              星空影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.to === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.to);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
                    isActive
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-foreground-300 hover:text-foreground-50 hover:bg-foreground-50/5'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative group">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-800/60 rounded-full border border-background-700/50 cursor-pointer hover:border-primary-500/40 transition-all duration-300">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-foreground-400 text-sm group-hover:text-primary-500 transition-colors duration-300"></i>
                </div>
                <input
                  type="text"
                  placeholder="搜索电影、剧集..."
                  className="bg-transparent text-sm text-foreground-200 placeholder-foreground-500 outline-none w-28 focus:w-40 transition-all duration-300"
                />
              </div>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-800/60 border border-background-700/50"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-300 text-lg ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          isMobileOpen ? 'max-h-80' : 'max-h-0'
        }`}
      >
        <div className="px-4 py-3 bg-background-900/95 backdrop-blur-lg border-t border-background-800/50 space-y-2">
          {navLinks.map((link) => {
            const isActive =
              link.to === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-foreground-50/5'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <div className="pt-2">
            <div className="flex items-center gap-2 px-4 py-2.5 bg-background-800/60 rounded-lg border border-background-700/50">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-foreground-400 text-sm"></i>
              </div>
              <input
                type="text"
                placeholder="搜索电影、剧集..."
                className="bg-transparent text-sm text-foreground-200 placeholder-foreground-500 outline-none w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}